var _style, _g, _g2, _g3, _g4, _path, _path2, _path3, _path4, _g5, _g6, _g7, _g8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStaticBlog9427(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120 120",
    style: {
      enableBackground: "new 0 0 120 120"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_2_);}\r\n\t.st2{fill:url(#SVGID_3_);}\r\n\t.st3{fill:url(#SVGID_4_);}\r\n\t.st4{opacity:0.2;}\r\n\t.st5{fill:#FFFFFF;}\r\n\t.st6{fill:#A0FFFF;}\r\n\t.st7{opacity:0.2;fill:#294256;}\r\n\t.st8{fill:#294256;}\r\n\t.st9{fill:#FF803C;}\r\n\t.st10{fill:#D4D9DD;}\r\n\t.st11{fill:#546878;}\r\n\t.st12{fill:#DDE1E4;}\r\n\t.st13{fill:#98A4AE;}\r\n\t.st14{fill:#FF8661;}\r\n\t.st15{fill:#00F5EB;}\r\n\t.st16{fill:#99FBF7;}\r\n\t.st17{fill:#FFB6A0;}\r\n\t.st18{opacity:0.5;}\r\n\t.st19{fill:#2D3445;}\r\n\t.st20{fill:#FF6A24;}\r\n\t.st21{opacity:0.1;}\r\n\t.st22{fill:#FFB633;}\r\n\t.st23{fill:#AEC4D6;}\r\n\t.st24{fill:#FFF0D6;}\r\n\t.st25{fill:#515B6B;}\r\n\t.st26{opacity:0.2;fill:#FFFFFF;}\r\n\t.st27{fill:#70839B;}\r\n\t.st28{fill:#2F3D57;}\r\n\t.st29{fill:#F58E60;}\r\n\t.st30{fill:#FFFBDA;}\r\n\t.st31{fill:#FCFCFC;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_10"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -116.6666,
    y1: -184.6525,
    x2: -24.5279,
    y2: -184.6525,
    gradientTransform: "matrix(-0.6844 0.7291 -0.7291 -0.6844 -127.7251 -16.097)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7CB1F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#5569CF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3A5D8B"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.18,92.85c-18.26-17.65-19.17-47.2-2.03-66C39.3,8.05,68,7.11,86.26,24.76 c18.26,17.65,19.17,47.2,2.03,66C71.15,109.56,42.44,110.5,24.18,92.85z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -99.1801,
    y1: -514.5534,
    x2: -6.7269,
    y2: -514.5534,
    gradientTransform: "matrix(-0.5939 -0.8045 0.8045 -0.5939 445.0571 -281.4822)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#82E9F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#5A9ACF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3E828B"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M35.61,29.15c20.15-15.32,48.55-10.91,63.42,9.84c14.87,20.75,10.6,49.98-9.55,65.3 c-20.15,15.31-48.55,10.91-63.42-9.84C11.19,73.69,15.46,44.46,35.61,29.15z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -439.4362,
    y1: -371.5946,
    x2: -348.7333,
    y2: -371.5946,
    gradientTransform: "matrix(0.9999 0.0124 -0.0124 0.9999 453.6766 434.5686)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7CB1F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#5569CF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3A5D8B"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M109.59,58.7c-0.31,25.79-20.86,46.43-45.91,46.11c-25.04-0.32-45.09-21.49-44.78-47.27 C19.2,31.76,39.76,11.11,64.8,11.43C89.85,11.75,109.9,32.92,109.59,58.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: -368.5002,
    y1: -517.7779,
    x2: -276.6841,
    y2: -517.7779,
    gradientTransform: "matrix(0.7673 -0.6413 0.6413 0.7673 632.8808 254.6613)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#82E9F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#5A9ACF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3E828B"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M88.1,34.3c16.06,19.79,13.5,49.24-5.71,65.77c-19.22,16.54-47.82,13.9-63.88-5.88 C2.45,74.41,5.01,44.96,24.22,28.42C43.44,11.88,72.04,14.52,88.1,34.3z"
  }))))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_13"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M33.23,84.28c10.96,15.09,32.16,18.45,47.25,7.48c15.09-10.96,18.45-32.16,7.48-47.25 c-10.96-15.09-32.16-18.45-47.25-7.48C25.63,47.99,22.27,69.18,33.23,84.28z M84.24,47.22c9.48,13.05,6.59,31.32-6.46,40.81 c-13.05,9.48-31.32,6.59-40.81-6.46c-9.48-13.05-6.59-31.32,6.46-40.81C56.48,31.27,74.75,34.17,84.24,47.22z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M84.28,96.98l0.36,0.5c-18.25,13.26-43.87,9.2-57.13-9.05l0.5-0.36C41.07,106.04,66.31,110.04,84.28,96.98z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M54.3,24.6l-0.1-0.61c-22.28,3.53-37.53,24.52-34,46.8l0.61-0.1C17.34,48.75,32.36,28.08,54.3,24.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M93.69,40.35c6.42,8.84,9.02,19.65,7.31,30.44l-0.61-0.1c1.68-10.63-0.87-21.28-7.2-29.98 C86.87,32.01,77.53,26.28,66.9,24.6l0.1-0.61C77.79,25.7,87.27,31.51,93.69,40.35z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M99.21,91.73c0,1.31-17,2.38-37.97,2.38c-20.97,0-37.97-1.07-37.97-2.38c0-1.31,17-2.38,37.97-2.38 C82.21,89.35,99.21,90.41,99.21,91.73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M90.07,85.99c0,1.71-1.39,3.1-3.1,3.1H34.5c-1.71,0-3.1-1.39-3.1-3.1V49.54c0-1.71,1.39-3.1,3.1-3.1h52.48 c1.71,0,3.1,1.39,3.1,3.1V85.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M88.01,85.99c0,0.57-0.46,1.03-1.03,1.03H34.5c-0.57,0-1.03-0.46-1.03-1.03V49.54c0-0.57,0.46-1.03,1.03-1.03 h52.48c0.57,0,1.03,0.46,1.03,1.03V85.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M26.78,90.13c0.12,0.52,0.52,0.78,1,0.78h66.18c0.48,0,0.88-0.26,1-0.78H26.78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M94.99,89.97v-1.39H26.74v1.39c0,0.09,0.02,0.16,0.04,0.16h68.17C94.97,90.13,94.99,90.06,94.99,89.97z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.86,
    y: 34.55,
    className: "st11",
    width: 45.76,
    height: 5.43
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.86,
    y: 39.98,
    className: "st5",
    width: 45.76,
    height: 47.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.86,
    y: 39.98,
    className: "st12",
    width: 45.76,
    height: 3.36
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.02,
    y: 89.09,
    className: "st10",
    width: 5.43,
    height: 0.52
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M48.37,37.15c0,0.48-0.39,0.86-0.86,0.86c-0.48,0-0.86-0.39-0.86-0.86c0-0.48,0.39-0.86,0.86-0.86 C47.98,36.29,48.37,36.67,48.37,37.15z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M45.78,37.15c0,0.48-0.39,0.86-0.86,0.86c-0.48,0-0.86-0.39-0.86-0.86c0-0.48,0.39-0.86,0.86-0.86 C45.4,36.29,45.78,36.67,45.78,37.15z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M43.2,37.15c0,0.48-0.39,0.86-0.86,0.86c-0.48,0-0.86-0.39-0.86-0.86c0-0.48,0.39-0.86,0.86-0.86 C42.81,36.29,43.2,36.67,43.2,37.15z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 41.73,
    y: 45.41,
    className: "st11",
    width: 36.71,
    height: 1.29
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.86,
    y: 48.51,
    className: "st11",
    width: 45.76,
    height: 11.63
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.48,
    y: 61.95,
    className: "st13",
    width: 25.08,
    height: 1.29
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.48,
    y: 64.53,
    className: "st13",
    width: 14.48,
    height: 1.29
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.22,
    y: 67.38,
    className: "st14",
    width: 17.32,
    height: 7.76
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.48,
    y: 76.94,
    className: "st13",
    width: 25.08,
    height: 1.29
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.48,
    y: 79.53,
    className: "st13",
    width: 14.48,
    height: 1.29
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.48,
    y: 82.11,
    className: "st13",
    width: 25.08,
    height: 1.29
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.48,
    y: 84.7,
    className: "st13",
    width: 14.48,
    height: 1.29
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.62,
    y: 65.57,
    className: "st15",
    width: 13.44,
    height: 9.82
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.62,
    y: 76.68,
    className: "st13",
    width: 13.44,
    height: 1.29
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.62,
    y: 61.95,
    className: "st13",
    width: 13.44,
    height: 1.29
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.62,
    y: 81.85,
    className: "st13",
    width: 13.44,
    height: 1.29
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.62,
    y: 79.27,
    className: "st13",
    width: 8.01,
    height: 1.29
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "69.91,75.39 81.03,75.39 78.79,72.25 77.06,74.35 72.93,69.66  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M77.41,70.49c0,0.33-0.27,0.6-0.6,0.6c-0.33,0-0.6-0.27-0.6-0.6c0-0.33,0.27-0.6,0.6-0.6 C77.14,69.89,77.41,70.16,77.41,70.49z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 41.48,
    y: 69.45,
    className: "st17",
    width: 9.56,
    height: 1.29
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.48,
    y: 72.03,
    className: "st17",
    width: 12.93,
    height: 1.29
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M50.19,52.42c0.25-0.06,0.57-0.08,0.92-0.08c0.39,0,0.77,0.05,1.06,0.3c0.22,0.19,0.32,0.47,0.32,0.76 c0,0.37-0.19,0.73-0.61,0.91v0.02c0.48,0.14,0.74,0.54,0.74,1c0,0.35-0.11,0.61-0.31,0.82c-0.25,0.27-0.67,0.42-1.37,0.42 c-0.31,0-0.57-0.02-0.76-0.04V52.42z M51.01,54.07h0.17c0.29,0,0.51-0.25,0.51-0.59c0-0.3-0.14-0.54-0.48-0.54 c-0.09,0-0.16,0.01-0.21,0.02V54.07z M51.01,55.93c0.05,0.01,0.11,0.01,0.18,0.01c0.33,0,0.6-0.2,0.6-0.63 c0-0.42-0.29-0.63-0.61-0.64h-0.17V55.93z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M53.19,52.35H54v3.49h1.07v0.69h-1.89V52.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M57.85,54.37c0,1.58-0.56,2.22-1.35,2.22c-0.95,0-1.32-1.01-1.32-2.15c0-1.14,0.45-2.13,1.38-2.13 C57.56,52.3,57.85,53.41,57.85,54.37z M56.02,54.44c0,0.95,0.18,1.43,0.51,1.43c0.34,0,0.47-0.62,0.47-1.47 c0-0.73-0.11-1.4-0.48-1.4C56.2,53.01,56.02,53.55,56.02,54.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M60.68,56.42c-0.18,0.07-0.56,0.15-0.87,0.15c-0.48,0-0.84-0.14-1.12-0.42c-0.36-0.35-0.55-0.97-0.54-1.69 c0.02-1.52,0.89-2.15,1.77-2.15c0.32,0,0.55,0.06,0.68,0.12l-0.14,0.7c-0.12-0.06-0.27-0.09-0.48-0.09 c-0.55,0-0.99,0.38-0.99,1.47c0,1.01,0.39,1.37,0.77,1.37c0.07,0,0.13-0.01,0.16-0.02v-1.01h-0.37v-0.66h1.12V56.42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M63.61,56.42c-0.18,0.07-0.56,0.15-0.87,0.15c-0.48,0-0.84-0.14-1.12-0.42c-0.36-0.35-0.55-0.97-0.54-1.69 c0.02-1.52,0.89-2.15,1.77-2.15c0.32,0,0.55,0.06,0.68,0.12l-0.14,0.7c-0.12-0.06-0.27-0.09-0.48-0.09 c-0.55,0-0.99,0.38-0.99,1.47c0,1.01,0.39,1.37,0.77,1.37c0.07,0,0.13-0.01,0.16-0.02v-1.01h-0.37v-0.66h1.12V56.42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M65.03,52.35v4.18h-0.81v-4.18H65.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M65.76,56.54v-4.18h0.74l0.65,1.64c0.12,0.32,0.33,0.86,0.45,1.22h0.01c-0.02-0.44-0.08-1.17-0.08-1.94 v-0.92h0.71v4.18H67.5l-0.64-1.59c-0.14-0.35-0.33-0.88-0.42-1.26h-0.01c0.02,0.42,0.05,1.07,0.05,1.9v0.94H65.76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M71.28,56.42c-0.18,0.07-0.56,0.15-0.87,0.15c-0.48,0-0.84-0.14-1.12-0.42c-0.36-0.35-0.55-0.97-0.54-1.69 c0.02-1.52,0.89-2.15,1.77-2.15c0.32,0,0.55,0.06,0.68,0.12l-0.14,0.7c-0.12-0.06-0.27-0.09-0.48-0.09 c-0.55,0-0.99,0.38-0.99,1.47c0,1.01,0.39,1.37,0.77,1.37c0.07,0,0.13-0.01,0.16-0.02v-1.01h-0.37v-0.66h1.12V56.42z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M27,37.66c-2.19,0-3.96,1.77-3.96,3.96c0,2.19,1.77,3.96,3.96,3.96c2.19,0,3.96-1.77,3.96-3.96 C30.96,39.44,29.19,37.66,27,37.66z M27,44.56c-1.62,0-2.93-1.31-2.93-2.93c0-1.62,1.31-2.93,2.93-2.93s2.93,1.31,2.93,2.93 C29.93,43.24,28.61,44.56,27,44.56z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 27,
    cy: 41.63,
    r: 1.72
  })), /*#__PURE__*/React.createElement("g", {
    className: "st18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M100.41,65.32c-2.19,0-3.96,1.77-3.96,3.96c0,2.19,1.77,3.96,3.96,3.96c2.19,0,3.96-1.77,3.96-3.96 C104.38,67.1,102.6,65.32,100.41,65.32z M100.41,72.22c-1.62,0-2.93-1.31-2.93-2.93s1.31-2.93,2.93-2.93s2.93,1.31,2.93,2.93 S102.03,72.22,100.41,72.22z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 100.41,
    cy: 69.29,
    r: 1.72
  })), /*#__PURE__*/React.createElement("g", {
    className: "st18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M40.18,95.57c-2.19,0-3.96,1.77-3.96,3.96c0,2.19,1.77,3.96,3.96,3.96c2.19,0,3.96-1.77,3.96-3.96 C44.15,97.34,42.37,95.57,40.18,95.57z M40.18,102.46c-1.62,0-2.93-1.31-2.93-2.93s1.31-2.93,2.93-2.93s2.93,1.31,2.93,2.93 S41.8,102.46,40.18,102.46z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 40.18,
    cy: 99.53,
    r: 1.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "32.65,76.88 32.18,77.35 33.18,78.36 34.19,79.36 34.66,78.89 35.1,78.45 33.09,76.44  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "35.93,75.61 34.79,75.94 35.6,76.75  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "34.79,75.94 33.09,76.44 35.1,78.45 35.6,76.75  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "32.18,77.35 30.77,78.76 27.06,82.47 28.2,83.6 29.07,84.48 32.78,80.77 34.19,79.36  "
  }), /*#__PURE__*/React.createElement("g", {
    className: "st21"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "29.77,79.75 27.06,82.47 27.46,82.87 27.61,83.02 30.32,80.3 32.73,77.9 32.18,77.35  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 26.3,
    y: 82.78,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -51.5384 43.9961)",
    className: "st19",
    width: 2.07,
    height: 2.84
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "29.33,57.3 11.75,57.3 11.75,65.57 25.96,65.57 27,67.48 27,65.57 29.33,65.57  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "25.25,58.98 25.46,59.62 26.14,59.62 25.59,60.06 25.8,60.72 25.25,60.33 24.71,60.73  24.92,60.05 24.37,59.62 25.04,59.62  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "22.67,58.98 22.88,59.62 23.56,59.62 23.01,60.06 23.22,60.72 22.67,60.33 22.12,60.73  22.33,60.05 21.78,59.62 22.46,59.62  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "20.08,58.98 20.29,59.62 20.97,59.62 20.42,60.06 20.63,60.72 20.08,60.33 19.54,60.73  19.75,60.05 19.2,59.62 19.87,59.62  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "17.5,58.98 17.71,59.62 18.39,59.62 17.84,60.06 18.05,60.72 17.5,60.33 16.95,60.73  17.16,60.05 16.61,59.62 17.29,59.62  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "14.91,58.98 15.12,59.62 15.8,59.62 15.25,60.06 15.46,60.72 14.91,60.33 14.37,60.73  14.58,60.05 14.03,59.62 14.7,59.62  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M20.28,61.69c0,0.14-0.12,0.26-0.26,0.26h-5.43c-0.14,0-0.26-0.12-0.26-0.26l0,0 c0-0.14,0.12-0.26,0.26-0.26h5.43C20.16,61.43,20.28,61.55,20.28,61.69L20.28,61.69z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M24.41,61.69c0,0.14-0.12,0.26-0.26,0.26h-2.84c-0.14,0-0.26-0.12-0.26-0.26l0,0 c0-0.14,0.12-0.26,0.26-0.26h2.84C24.3,61.43,24.41,61.55,24.41,61.69L24.41,61.69z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M17.69,62.73c0,0.14-0.12,0.26-0.26,0.26h-2.84c-0.14,0-0.26-0.12-0.26-0.26l0,0 c0-0.14,0.12-0.26,0.26-0.26h2.84C17.58,62.47,17.69,62.58,17.69,62.73L17.69,62.73z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M20.28,62.73c0,0.14-0.12,0.26-0.26,0.26h-1.55c-0.14,0-0.26-0.12-0.26-0.26l0,0 c0-0.14,0.12-0.26,0.26-0.26h1.55C20.16,62.47,20.28,62.58,20.28,62.73L20.28,62.73z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M16.4,63.76c0,0.14-0.12,0.26-0.26,0.26h-1.55c-0.14,0-0.26-0.12-0.26-0.26l0,0 c0-0.14,0.12-0.26,0.26-0.26h1.55C16.28,63.5,16.4,63.62,16.4,63.76L16.4,63.76z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M22.86,62.73c0,0.14-0.12,0.26-0.26,0.26h-1.55c-0.14,0-0.26-0.12-0.26-0.26l0,0 c0-0.14,0.12-0.26,0.26-0.26h1.55C22.75,62.47,22.86,62.58,22.86,62.73L22.86,62.73z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st23",
    cx: 17.37,
    cy: 63.84,
    r: 0.26
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st23",
    cx: 18.4,
    cy: 63.84,
    r: 0.26
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st23",
    cx: 19.44,
    cy: 63.84,
    r: 0.26
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 94.19,
    y: 78.68,
    transform: "matrix(1 -9.160621e-03 9.160621e-03 1 -0.7321 0.884)",
    className: "st22",
    width: 3.88,
    height: 3.36
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "101.72,83.54 98.09,82.02 98.06,78.66 101.66,76.82  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.42,
    y: 79.47,
    transform: "matrix(1 -9.285551e-03 9.285551e-03 1 -0.7411 0.8745)",
    className: "st25",
    width: 0.78,
    height: 1.55
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M102.64,80.21c0,0.5-0.4,0.91-0.9,0.91c-0.02,0-0.03,0-0.04,0l-0.02-1.8c0.02,0,0.03,0,0.04,0 c0.39,0,0.73,0.24,0.86,0.59C102.62,80,102.64,80.11,102.64,80.21z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.48,
    y: 82.05,
    transform: "matrix(1 -9.024633e-03 9.024633e-03 1 -0.7482 0.8607)",
    className: "st25",
    width: 1.03,
    height: 2.58
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "94.18,78.69 98.06,78.66 98.07,79.95 93.41,79.99 93.41,79.48 94.19,79.47  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M102.58,79.91l-0.9,0.01l-0.01-0.6c0.02,0,0.03,0,0.04,0C102.12,79.31,102.46,79.56,102.58,79.91z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.48,
    y: 79.19,
    transform: "matrix(1 -9.381464e-03 9.381464e-03 1 -0.7399 0.9053)",
    className: "st5",
    width: 1.29,
    height: 0.26
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "102.74,42.56 92.92,42.56 92.92,56 104.29,56 104.29,44.34  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 94.6,
    y: 52.49,
    className: "st27",
    width: 8.14,
    height: 0.52
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 94.6,
    y: 51.19,
    className: "st27",
    width: 4.85,
    height: 0.52
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 94.6,
    y: 49.9,
    className: "st27",
    width: 8.14,
    height: 0.52
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 94.6,
    y: 48.61,
    className: "st27",
    width: 8.14,
    height: 0.52
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 94.6,
    y: 47.32,
    className: "st27",
    width: 5.36,
    height: 0.52
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 94.6,
    y: 46.02,
    className: "st27",
    width: 8.14,
    height: 0.52
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 94.6,
    y: 44.73,
    className: "st27",
    width: 8.14,
    height: 0.52
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "102.48,44.37 104.42,44.37 102.48,42.66  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 62.16,
    y: 19.55,
    className: "st28",
    width: 14.99,
    height: 2.07
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 62.16,
    y: 21.62,
    className: "st29",
    width: 14.99,
    height: 9.82
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 73.79,
    y: 25.24,
    className: "st30",
    width: 1.03,
    height: 3.62
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 72.24,
    y: 23.69,
    className: "st30",
    width: 1.03,
    height: 5.17
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 70.69,
    y: 26.28,
    className: "st30",
    width: 1.03,
    height: 2.59
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 69.14,
    y: 27.31,
    className: "st30",
    width: 1.03,
    height: 1.55
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 67.58,
    y: 24.47,
    className: "st30",
    width: 1.03,
    height: 4.39
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 66.03,
    y: 23.17,
    className: "st30",
    width: 1.03,
    height: 5.69
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 64.48,
    y: 26.79,
    className: "st30",
    width: 1.03,
    height: 2.07
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st30",
    cx: 65.18,
    cy: 20.63,
    r: 0.26
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st30",
    cx: 64.41,
    cy: 20.63,
    r: 0.26
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st30",
    cx: 63.63,
    cy: 20.63,
    r: 0.26
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M35.27,36.16c0,0.25-0.2,0.45-0.45,0.45h-0.13c-0.25,0-0.45-0.2-0.45-0.45v-0.9c0-0.25,0.2-0.45,0.45-0.45 h0.13c0.25,0,0.45,0.2,0.45,0.45V36.16z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.98,
    y: 34.03,
    className: "st28",
    width: 1.55,
    height: 1.81
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M37.68,30.86c0-1.62-1.31-2.93-2.93-2.93c-1.62,0-2.93,1.31-2.93,2.93c0,1.25,0.79,2.32,1.9,2.74v1.21h2.07 V33.6C36.9,33.18,37.68,32.11,37.68,30.86z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.72,
    y: 34.55,
    className: "st28",
    width: 2.07,
    height: 0.52
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 34.24,
    y: 31.7,
    className: "st28",
    width: 0.26,
    height: 2.84
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 35.01,
    y: 31.7,
    className: "st28",
    width: 0.26,
    height: 2.84
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M22.93,77.46c0,0.52-0.56,1.03-1.23,1.03h-2.33c-0.64,0-1.42-0.48-1.42-1.12v-0.26 c0-0.64,0.78-1.21,1.42-1.21h2.2v0.26h-2.2c-0.5,0-1.16,0.45-1.16,0.95v0.26c0,0.5,0.66,0.86,1.16,0.86h2.33 c0.52,0,0.97-0.52,0.97-0.78H22.93z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M25.96,77.12v0.26c0,0.64-0.26,1.12-0.9,1.12H22.6v-0.26h2.46c0.5,0,0.65-0.36,0.65-0.86v-0.26 c0-0.5-0.15-0.95-0.65-0.95h-2.33c-0.48,0-0.84,0.52-0.84,1.03h-0.26c0-0.78,0.47-1.29,1.1-1.29h2.33 C25.7,75.91,25.96,76.48,25.96,77.12z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M51.56,27.31v-6.72H43.8v9.05h5.43v0.28l0.18-0.18l2.14-2.19l0.18-0.23H51.56z M44.06,29.38v-8.53h7.24 v6.46h-2.07v2.07H44.06z M49.49,29.3v-1.73h1.63L49.49,29.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 45.09,
    y: 22.14,
    className: "st5",
    width: 5.43,
    height: 0.26
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 45.09,
    y: 23.17,
    className: "st5",
    width: 3.36,
    height: 0.26
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 45.35,
    y: 24.47,
    className: "st5",
    width: 4.14,
    height: 0.26
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 45.09,
    y: 25.76,
    className: "st5",
    width: 2.07,
    height: 0.26
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M95.2,27.84c0.57,0,1.03-0.46,1.03-1.03c0-0.57-0.46-1.03-1.03-1.03s-1.03,0.46-1.03,1.03 C94.17,27.38,94.63,27.84,95.2,27.84z M95.2,26.03c0.43,0,0.78,0.35,0.78,0.78c0,0.43-0.35,0.78-0.78,0.78 c-0.43,0-0.78-0.35-0.78-0.78C94.43,26.38,94.77,26.03,95.2,26.03z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M95.2,33.27c-0.35,0-0.66,0.18-0.85,0.44l-3.39-2.3c0.14-0.21,0.23-0.46,0.23-0.73 c0-0.23-0.07-0.45-0.17-0.64l3.48-2.36l-0.15-0.21l-3.48,2.36c-0.24-0.27-0.58-0.45-0.97-0.45c-0.71,0-1.29,0.58-1.29,1.29 c0,0.71,0.58,1.29,1.29,1.29c0.35,0,0.66-0.14,0.9-0.37l3.44,2.33c-0.04,0.11-0.07,0.23-0.07,0.36c0,0.57,0.46,1.03,1.03,1.03 s1.03-0.46,1.03-1.03C96.24,33.73,95.77,33.27,95.2,33.27z M89.9,31.72c-0.57,0-1.03-0.46-1.03-1.03c0-0.57,0.46-1.03,1.03-1.03 s1.03,0.46,1.03,1.03C90.94,31.26,90.47,31.72,89.9,31.72z M95.2,35.08c-0.43,0-0.78-0.35-0.78-0.78c0-0.43,0.35-0.78,0.78-0.78 c0.43,0,0.78,0.35,0.78,0.78C95.98,34.73,95.63,35.08,95.2,35.08z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M113.86,60.01c0-0.36-0.29-0.65-0.65-0.65h-7.5c-0.36,0-0.65,0.29-0.65,0.65v5.43 c0,0.36,0.29,0.65,0.65,0.65h7.5c0.36,0,0.65-0.29,0.65-0.65V60.01z M105.93,59.62h7.5c0.21,0,0.17,0.29,0.17,0.51v3.21 l-1.91,0.73l-1.61-2.18l-2.75,2.25l-1.82-1.56l-0.18,0.1v-2.54C105.33,59.92,105.72,59.62,105.93,59.62z M113.43,65.83h-7.5 c-0.21,0-0.61-0.05-0.61-0.27v-2.71l1.91,1.63l2.79-2.23l1.53,2.12l2.03-0.76v1.94C113.6,65.77,113.64,65.83,113.43,65.83z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M112.09,61.94c0.36,0,0.65-0.29,0.65-0.65s-0.29-0.65-0.65-0.65c-0.36,0-0.65,0.29-0.65,0.65 S111.74,61.94,112.09,61.94z M112.09,60.91c0.21,0,0.39,0.17,0.39,0.39c0,0.21-0.17,0.39-0.39,0.39c-0.21,0-0.39-0.17-0.39-0.39 C111.7,61.08,111.88,60.91,112.09,60.91z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M20.54,48.38c0-0.36-0.29-0.65-0.65-0.65h-7.76c-0.36,0-0.65,0.29-0.65,0.65v5.95 c0,0.36,0.29,0.65,0.65,0.65h7.76c0.36,0,0.65-0.29,0.65-0.65V48.38z M20.28,54.42c0,0.21-0.09,0.29-0.3,0.29h-7.76 c-0.21,0-0.47-0.07-0.47-0.29v-0.75h8.53V54.42z M20.28,53.42h-8.53v-4.94c0-0.21,0.26-0.49,0.47-0.49h7.76 c0.21,0,0.3,0.27,0.3,0.49V53.42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M15.2,52.59l2.71-1.57l-2.72-1.58L15.2,52.59z M17.4,51.02l-1.94,1.12l-0.01-2.25L17.4,51.02z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "111.79,74.1 110.75,74.1 110.75,73.07 110.5,73.07 110.5,74.1 109.46,74.1 109.46,74.36  110.5,74.36 110.5,75.39 110.75,75.39 110.75,74.36 111.79,74.36  "
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M103.08,88.26c-0.74,0-1.34-0.6-1.34-1.34c0-0.74,0.6-1.34,1.34-1.34c0.74,0,1.34,0.6,1.34,1.34 C104.41,87.66,103.81,88.26,103.08,88.26z M103.08,85.84c-0.59,0-1.08,0.48-1.08,1.08c0,0.59,0.48,1.08,1.08,1.08 c0.59,0,1.08-0.48,1.08-1.08C104.15,86.33,103.67,85.84,103.08,85.84z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M36.64,25.18c-0.74,0-1.34-0.6-1.34-1.34c0-0.74,0.6-1.34,1.34-1.34c0.74,0,1.34,0.6,1.34,1.34 C37.98,24.58,37.38,25.18,36.64,25.18z M36.64,22.77c-0.59,0-1.08,0.48-1.08,1.08c0,0.59,0.48,1.08,1.08,1.08 c0.59,0,1.08-0.48,1.08-1.08C37.72,23.25,37.23,22.77,36.64,22.77z"
  })))))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_8"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_8_copy"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_12"
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_13_copy"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -246.3653 145.0996)",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      display: "inline",
      fill: "#939598",
      fontFamily: "'Mont-Regular'",
      fontSize: "8.9637px"
    }
  }, "A simple shopping cart like in Amazon"), /*#__PURE__*/React.createElement("tspan", {
    x: 171.71,
    y: 0,
    style: {
      display: "inline",
      fill: "#2B29A1",
      fontFamily: "'MyriadPro-Regular'",
      fontSize: "79.7258px"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaticBlog9427);
export default __webpack_public_path__ + "static/media/static-blog-9427.e3cfbb1a411ded54703fb294a20ee9cc.svg";
export { ForwardRef as ReactComponent };